import React from 'react';
import { NavLink } from 'react-router-dom';
import { SubNav } from 'components/navigation/SubNav.style.js';

const ContactSubNav = (props) => {
  return (
    <SubNav>
      <NavLink exact to='/work-with-me' activeClassName='current-item'><h1>Work With Me</h1></NavLink><span>/</span>
      <NavLink to='/contact' activeClassName='current-item'><h1>General Enquiries</h1></NavLink>
    </SubNav>
  );
};

export default ContactSubNav;



// WEBPACK FOOTER //
// ./src/components/navigation/ContactSubNav.js